import { MutationTree } from 'vuex';
import { StorageItems, StorageItemSiteInfo } from '@/entities/storage.items';
import { Attributes } from '@/entities/page.attributes';
import Organization from '@/entities/organization';
import PageContext from '@/entities/page..context';
import { AppState } from '@/store/mainModule/state';
import { Modal } from '@/entities/modal';
import { DEVICE } from '@/entities/device';
import { WidgetsInfo } from '@/entities/widget.info';


export const mutations: MutationTree<AppState> = {
  clearAll(state: AppState): void {
    state.userOrganizationList = null;
    state.storageItems = null;
    state.pageAttributesMap = null;
    state.messages = null;
  },

  setStorageItems(state: AppState, payload: StorageItems): void {
    state.storageItems = payload;
  },

  setStorageSiteInfo(state: AppState, payload: StorageItemSiteInfo): void {
    state.storageItems = state.storageItems || new StorageItems();
    state.storageItems.setSiteInfo(payload);
  },

  setPageAttributesMap(state: AppState, payload: Map<number, Attributes>): void {
    state.pageAttributesMap = payload;
  },

  setUserOrganizationList(state: AppState, payload: Array<Organization>): void {
    state.userOrganizationList = payload;
  },

  setMessages(state: AppState, payload: Map<string, string>): void {
    state.messages = payload;
  },

  setWidgetsInfo(state: AppState, payload: WidgetsInfo): void {
    state.widgetsInfo = payload;
  },

  setMobileView(state: AppState, payload: boolean): void {
    state.isMobileView = payload;
  },

  setTouchScreen(state: AppState, payload: boolean): void {
    state.isTouchScreen = payload;
  },

  setPageContext(state: AppState, payload: PageContext): void {
    state.pageContext = payload;
  },

  setApiEndpoints(state: AppState, payload: any): void {
    state.apiEndpoints = payload;
  },
  setModal(state: AppState, payload: Modal): void {
    state.modal = payload;
  },

  setLanguageCode(state: AppState, payload: string): void {
    state.languageCode = payload;
  },

  setDevice(state: AppState, payload: Array<DEVICE>): void {
    state.device = payload;
  },

  setLoginJstate(state: AppState, payload: string): void {
    state.loginJstate = payload;
  },

};
